import { Helmet } from 'react-helmet-async';

const siteUrl = process.env.REACT_APP_SITE_URL || 'https://drivor.in';

const SEOHead = ({
  title,
  absoluteTitle,
  description,
  keywords,
  image,
  imageAlt,
  url,
  type = 'website',
  structuredData,
  noindex = false,
}) => {
  const defaultTitle = 'Drivor | Driver and cab hire for city, airport, office, and outstation travel';
  const defaultDescription = 'Book verified drivers and well-maintained cabs through Drivor for city drives, airport transfers, office pickup and drop, outstation trips, and holiday travel.';
  const defaultKeywords = 'Drivor, driver hire, cab hire, airport transfer, outstation trip, office pickup and drop, corporate driver, Bengaluru, Chennai';
  const defaultImage = `${siteUrl}/brand/icon-512.png`;
  const defaultImageAlt = imageAlt || 'Drivor';

  const seoTitle = absoluteTitle || (title ? `${title} | Drivor` : defaultTitle);
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoImage = image || defaultImage;
  const seoImageAlt = imageAlt || defaultImageAlt;
  const seoUrl = url || siteUrl;
  const robotsContent = noindex ? 'noindex, follow' : 'index, follow';

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="robots" content={robotsContent} />
      <meta name="author" content="Drivor" />
      <link rel="canonical" href={seoUrl} />

      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      {seoImage && <meta property="og:image" content={seoImage} />}
      {seoImage && seoImageAlt && <meta property="og:image:alt" content={seoImageAlt} />}
      {seoImage && <meta property="og:image:width" content="1200" />}
      {seoImage && <meta property="og:image:height" content="630" />}
      <meta property="og:url" content={seoUrl} />
      <meta property="og:site_name" content="Drivor" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      {seoImage && <meta name="twitter:image" content={seoImage} />}
      {seoImage && seoImageAlt && <meta name="twitter:image:alt" content={seoImageAlt} />}

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
